import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ILogin, IRegister } from '../../../../models/auth.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import { UserRoles } from '../../../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  TOKEN_KEY = 'access_token';
  redirectUrl: string;
  userRoles = UserRoles;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private tokenDecoder: JwtHelperService
  ) { }

  setAuthToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  navigateByUrl(url: string): void {
    this.router.navigateByUrl(url);
  }

  login(userDetails: ILogin): Observable<ISibasiHTTPResponse<{access_token: string}>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<{access_token: string}>>(`${environment.api_url}/user/loginWithEmail`, userDetails).pipe(
      map((res) => {
        const token = res.result.access_token;
        this.setAuthToken(token);
        const redirectUrl = this.redirectUrl || '/';

        this.navigateByUrl(redirectUrl);
        return res;
      })
    );
  }

  register(userDetails: IRegister): Observable<ISibasiHTTPResponse<{access_token: string}>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<{access_token: string}>>(`${environment.api_url}/user/signupWithUsernameAndEmail`, userDetails).pipe(
      map((res) => {
        const token = res.result.access_token;
        this.setAuthToken(token);
        const redirectUrl = this.redirectUrl || '/';
        this.navigateByUrl(redirectUrl);
        return res;
      })
    );
  }

  forgotPassword(email: string): Observable<ISibasiHTTPResponse<any>> {
    return this.httpClient.post<ISibasiHTTPResponse<any>>(`${environment.api_url}/user/forgotPassword`, email);
  }

  resetPassword(resetDetails: any): Observable<ISibasiHTTPResponse<any>> {
    return this.httpClient.post<ISibasiHTTPResponse<any>>(`${environment.api_url}/user/resetPassword`, resetDetails);
  }
  verifyEmail(verifyDetails): Observable<ISibasiHTTPResponse<{}>> {
    return this.httpClient.post<ISibasiHTTPResponse<{}>>(`${environment.api_url}/user/verifyAccount`, verifyDetails );
  }
  getAuthToken(): string {
    const token = localStorage.getItem(this.TOKEN_KEY);
    return token;
  }

  isLoggedIn(): boolean {
    const token = this.getAuthToken();
    if (token) {
      const isTokenExpired = this.tokenDecoder.isTokenExpired(token);
      return isTokenExpired ? false : true;
    }
    return false;
  }

  logout(): void {
    localStorage.clear();
    this.redirectUrl = '/';
    this.navigateByUrl('/auth/login');
  }

  isUserAllowedToView(allowedUsers: any): boolean {

    // if (allowedUsers === 'all') {
    //   return true;
    // }
    // const userRoles = this.getDecodedToken().roles;

    // let found = false;
    // // tslint:disable-next-line: prefer-for-of
    // for (let i = 0; i < allowedUsers.length; i++) {
    //     if (userRoles.indexOf(allowedUsers[i]) > -1) {
    //         found = true;
    //         break;
    //     }
    // }
    // return found ? true : false;

    return true;
  }

  decodedToken(): any {
    const token = this.getAuthToken();
    return token ?
      this.tokenDecoder.decodeToken(token) :
      {};
  }

  isUserAPatient(): boolean {
    const decodedToken = this.decodedToken();
    const userRoles = decodedToken.roles;
    if (
      userRoles?.includes(this.userRoles.USER) &&
      userRoles?.includes(this.userRoles.PATIENT) &&
      userRoles?.length === 2
    ) {
      return true;
    }
    return false;
  }

  isUserANewUser(): boolean {
    const decodedToken = this.decodedToken();
    const userRoles = decodedToken.roles;
    if (
      userRoles?.includes(this.userRoles.USER) &&
      userRoles?.length === 1
    ) {
      return true;
    }
    return false;
  }

doesHaveRole(userRole: string[]){
  const decodedToken = this.decodedToken();
  const userRoles = decodedToken.roles;
  if (
    userRoles?.some(r=> userRole.includes(r))
    ) {
    return true;
  }
  return false;
}

}
